import axios from 'axios'
import store from '../store'

export default () => {
  let instance = axios.create({
    baseURL: process.env.VUE_APP_AVANTI_SEARCH_API_URL,
    withCredentials: false,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=UTF-8'
    }
  })

  // Intercept requests - and start progress bar
  instance.interceptors.request.use(config => {
    // NProgress.start()
    return config
  })

  // Intercept responses - and stop progress bar
  instance.interceptors.response.use(
    response => {
      return response
    },
    error => {
      console.log('Intercepted error in NODE API')
      console.log('Code: ', error.response)

      if (error.response) {
        if (error.response.status === 418) {
          console.log('Token Expired/Invalid - dispatch login modal?')

          // Make sure this only happens one time
          const currentModal = store.getters.getCurrentModal

          if (!(currentModal && currentModal.modalName === 'login-modal')) {
            console.log('Show the login modal')

            store.dispatch('OPEN_MODAL', {
              modalName: 'login-modal',
              modalProps: null,
              modalType: null,
              modalOnCloseEvent: null
            })
          }
        } else if (error.response.status === 403) {
          // Don't really don anything here, i guess. This happens when no access granted...
        }
      }

      return Promise.reject(error)
    }
  )

  return instance
}



// WEBPACK FOOTER //
// ./src/services/ApiNode.js